<template>
  <div class="footer mt-3 mb-3 text-muted">
    <small>Copyright MXD LLC</small>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.footer {
  position: fixed;
  bottom: 0;
}
</style>
